<template>
  <div class="reload-panel">
    <p>This is a lot of data! We are still calculating it for you...</p>
    <p>Please wait just a few moments and then reload.</p>
    <button
      class="reload-button button"
      @click="reloadChart"
    >
      Reload
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    chartAttr: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('charts', [
      'fetchCurrentChartData'
    ]),
    reloadChart () {
      this.fetchCurrentChartData(this.chartAttr.name)
    }
  }
}
</script>

<style scoped lang="scss">
.reload-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;

  .reload-button {
    width: 80px;
    height: 22px;
    margin-top: 17px;
    color: black;
    font-size: 10px;
  }
}
</style>
